import React, { useEffect } from "react"
import { Alert, Spinner } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"
import { confirmRegisterAction } from "../../pages/comfirmRegistration/confirmRegistrationAction"
import { Link } from "react-router-dom"

import "./confirmRegistration.css"

const ConfirmRegistrationTable = () => {
  const dispatch = useDispatch()

  const { ConfirmRegisterResponse, isLoading } = useSelector(
    (state) => state.ConfirmRegister
  )
  let query = new URLSearchParams(useLocation().search)
  const email = query.get("email")
  const otp = query.get("otp")

  useEffect(() => {
    email && otp && dispatch(confirmRegisterAction({ email, otp }))
  }, [dispatch, email, otp])

  return (
    <div className="register">
      {isLoading && <Spinner variant="primary" animation="border"></Spinner>}

      {ConfirmRegisterResponse?.message && (
        <Alert
          variant={
            ConfirmRegisterResponse?.status === "success" ? "success" : "danger"
          }
        >
          {ConfirmRegisterResponse?.message}
        </Alert>
      )}
      {ConfirmRegisterResponse?.status === "success" && (
        <Link to={"/"} className="login-link">
          <span>Continue to Login</span>
        </Link>
      )}
    </div>
  )
}

export default ConfirmRegistrationTable
